import { useTranslation } from 'react-i18next';
import { useMatch, useNavigate, useParams } from 'react-router-dom';
import {
  RESTAURANT_USER_ROLE,
  useAuthUserRestaurant,
  useGetSingleMenuTypeQuery,
} from '@durma-soft/gros-sdk';

import { Modal } from '@/components/shared/modal';
import { Alert } from '@/components/shared/alert';
import { ModalFormSkeleton } from '@/components/shared/modal-form-skeleton';
import { EditRestaurantMenuTypeForm } from '@/components/restaurant/menu-types/edit-restaurant-menu-type-form';

export const EditRestaurantMenuTypeModal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { menuTypeId } = useParams();

  if (!menuTypeId) {
    throw new Error('Menu type ID is required for editing menu type');
  }

  const restaurant = useAuthUserRestaurant();
  const hasEditPermission = restaurant.role !== RESTAURANT_USER_ROLE.EMPLOYEE;

  const {
    data: menuType,
    isSuccess,
    isError,
    isLoading,
  } = useGetSingleMenuTypeQuery({
    menu_type_id: Number(menuTypeId),
    restaurant_id: restaurant.id,
  });

  const closeModal = () =>
    navigate('/restaurant/menu-types', { replace: true });

  const isModalOpen = Boolean(
    useMatch({ path: '/restaurant/menu-types/edit/:menuTypeId' }),
  );

  return (
    <Modal
      key={menuTypeId}
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      title={t('menu-type.edit')}
      description={t('menu-type.edit-details')}
    >
      {isLoading && <ModalFormSkeleton />}
      {!hasEditPermission && (
        <Alert
          variant="destructive"
          title={t('common.edit-not-allowed')}
          description={t('common.edit-not-allowed-description')}
        />
      )}
      {isError && hasEditPermission && (
        <Alert
          variant="destructive"
          title={t('common.error')}
          description={t('common.try-later')}
        />
      )}
      {isSuccess && hasEditPermission && (
        <EditRestaurantMenuTypeForm menuType={menuType} onClose={closeModal} />
      )}
    </Modal>
  );
};
